<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 4C20.5304 4 21.039 4.21086 21.4141 4.58594C21.7891 4.96101 22 5.46957 22 6V9.5C22 9.77614 21.7724 9.99417 21.5049 10.0625C21.16 10.1506 20.8419 10.33 20.5859 10.5859C20.2109 10.961 20 11.4696 20 12C20 12.5304 20.2109 13.039 20.5859 13.4141C20.8419 13.67 21.16 13.8494 21.5049 13.9375C21.7724 14.0058 22 14.2239 22 14.5V18C22 18.5304 21.7891 19.039 21.4141 19.4141C21.039 19.7891 20.5304 20 20 20H4C3.46957 20 2.96101 19.7891 2.58594 19.4141C2.21086 19.039 2 18.5304 2 18V14.5C2 14.2239 2.22756 14.0058 2.49512 13.9375C2.83999 13.8494 3.1581 13.67 3.41406 13.4141C3.78914 13.039 4 12.5304 4 12C4 11.4696 3.78914 10.961 3.41406 10.5859C3.1581 10.33 2.83999 10.1506 2.49512 10.0625C2.22756 9.99417 2 9.77614 2 9.5V6C2 5.46957 2.21086 4.96101 2.58594 4.58594C2.96101 4.21086 3.46957 4 4 4H20ZM10.959 13.627L8.25 10.9199L7 12.1699L11.166 16.3359L17 8.83594L15.541 7.58594L10.959 13.627Z"
      fill="currentColor"
    />
  </svg>
</template>
